export interface TextBackgroundAdjustments {
  roundness?: number;
  width?: number;
  height?: number;
  offsetX?: number;
  offsetY?: number;
}

export interface ResolvedTextBackgroundBox {
  x: number;
  y: number;
  width: number;
  height: number;
  radius: number;
}

/** Resolves authored 1080-reference background controls into canvas pixels. */
export function resolveTextBackgroundBox(
  baseX: number,
  baseY: number,
  baseWidth: number,
  baseHeight: number,
  fontSizePx: number,
  referenceScale: number,
  adjustments: TextBackgroundAdjustments | null | undefined,
): ResolvedTextBackgroundBox {
  const widthScale = clamp(finiteOr(adjustments?.width, 1), 0.25, 2);
  const heightScale = clamp(finiteOr(adjustments?.height, 1), 0.25, 2);
  const width = Math.max(1, baseWidth * widthScale);
  const height = Math.max(1, baseHeight * heightScale);
  const centerX = baseX + baseWidth / 2 + clamp(finiteOr(adjustments?.offsetX, 0), -100, 100) * referenceScale;
  const centerY = baseY + baseHeight / 2 + clamp(finiteOr(adjustments?.offsetY, 0), -100, 100) * referenceScale;
  const roundness = adjustments?.roundness;
  const radius = Number.isFinite(roundness)
    ? Math.min(width, height) * 0.5 * clamp(roundness as number, 0, 1)
    : Math.min(fontSizePx * 0.3, 18);

  return { x: centerX - width / 2, y: centerY - height / 2, width, height, radius };
}

function finiteOr(value: number | null | undefined, fallback: number): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : fallback;
}

function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}
